import { useState } from 'react';
import { reportError } from '@/lib/errorReporter';

// Floating "Zgłoś błąd" — widoczny zawsze, dla każdego (zalogowany i nie).
// Klik otwiera prosty modal z polem opisu. Po wysłaniu zapisuje do error_logs z source="user_report".

export default function ReportBugButton() {
  const [open, setOpen] = useState(false);
  const [desc, setDesc] = useState('');
  const [sending, setSending] = useState(false);
  const [sentId, setSentId] = useState(null);

  const submit = async () => {
    if (!desc.trim() || sending) return;
    setSending(true);
    try {
      await reportError({
        source: 'user_report',
        level: 'info',
        message: desc.trim().slice(0, 1000),
        context: {
          type: 'user_report',
          user_description: desc.trim(),
          // recent console errors już są reportowane osobno; tu sygnał od użytkownika
        },
      });
      setSentId(Date.now());
      setDesc('');
      setTimeout(() => {
        setOpen(false);
        setSentId(null);
      }, 1500);
    } finally {
      setSending(false);
    }
  };

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        title="Zgłoś błąd / problem"
        style={btnFloat}
      >
        Zgłoś błąd
      </button>

      {open && (
        <div style={overlay} onClick={() => !sending && setOpen(false)}>
          <div style={modal} onClick={(e) => e.stopPropagation()}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
              <div style={{ fontSize: 18, fontWeight: 600 }}>Zgłoś błąd</div>
              <button onClick={() => setOpen(false)} style={btnClose}>x</button>
            </div>
            <p style={{ opacity: 0.7, fontSize: 13, marginBottom: 8 }}>
              Opisz co próbujesz zrobić, co widzisz i co nie działa. Trafi do admina razem z adresem strony, na której jesteś.
            </p>
            <textarea
              value={desc}
              onChange={(e) => setDesc(e.target.value)}
              placeholder="Co poszło nie tak?"
              autoFocus
              style={textarea}
              maxLength={1000}
            />
            <div style={{ display: 'flex', gap: 8, marginTop: 12, justifyContent: 'flex-end', alignItems: 'center' }}>
              {sentId && <span style={{ color: '#7cd97c', fontSize: 13 }}>Wysłane, dziękujemy.</span>}
              <button onClick={() => setOpen(false)} style={btnSec} disabled={sending}>Anuluj</button>
              <button onClick={submit} style={btnPrim} disabled={sending || !desc.trim()}>
                {sending ? 'Wysyłam…' : 'Wyślij zgłoszenie'}
              </button>
            </div>
            <div style={{ marginTop: 8, fontSize: 11, opacity: 0.5 }}>
              {typeof window !== 'undefined' && `URL: ${window.location.pathname}${window.location.search}`}
            </div>
          </div>
        </div>
      )}
    </>
  );
}

const btnFloat = {
  position: 'fixed',
  bottom: 16,
  right: 16,
  zIndex: 9998,
  padding: '10px 14px',
  background: '#7c3aed',
  color: 'white',
  border: 'none',
  borderRadius: 999,
  cursor: 'pointer',
  fontSize: 13,
  fontWeight: 600,
  boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
};

const overlay = {
  position: 'fixed',
  inset: 0,
  background: 'rgba(0,0,0,0.6)',
  zIndex: 9999,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: 16,
};

const modal = {
  background: '#1a1a22',
  color: '#e6e6e6',
  borderRadius: 8,
  padding: 20,
  width: '100%',
  maxWidth: 480,
  boxShadow: '0 10px 40px rgba(0,0,0,0.5)',
  border: '1px solid #2a2a35',
};

const textarea = {
  width: '100%',
  minHeight: 100,
  background: '#0f0f14',
  color: '#e6e6e6',
  border: '1px solid #2a2a35',
  borderRadius: 6,
  padding: 10,
  fontFamily: 'inherit',
  fontSize: 14,
  resize: 'vertical',
};

const btnPrim = {
  padding: '8px 14px',
  background: '#7c3aed',
  color: 'white',
  border: 'none',
  borderRadius: 6,
  cursor: 'pointer',
  fontWeight: 600,
};

const btnSec = {
  padding: '8px 14px',
  background: 'transparent',
  color: '#e6e6e6',
  border: '1px solid #3a3a45',
  borderRadius: 6,
  cursor: 'pointer',
};

const btnClose = {
  background: 'transparent',
  color: '#888',
  border: 'none',
  fontSize: 18,
  cursor: 'pointer',
  padding: '0 6px',
};
